import ApiGenericServicesData from 'services/ApiGenericServicesData';
import UserSecurity from 'services/UserSecurity';
import User from 'services/User';
import Company from 'services/Company';
import SolicitudesDeEmpadronamiento from 'services/SolicitudesDeEmpadronamiento'
import RegistrosDeContactoParaValidarDatosDeSolicitudesConCiudadanos from 'services/RegistrosDeContactoParaValidarDatosDeSolicitudesConCiudadanos'
import Empadronamiento from 'services/Empadronamiento'
import VerificarSolicitudDeEmpadronamiento from 'services/VerificarSolicitudDeEmpadronamiento'
import ConstanciaEmpadronamiento from 'services/ConstanciaEmpadronamiento'
import VerificarHomonimos from 'services/VerificarHomonimos'
import ConsultarDatosDeFallecidos from 'services/ConsultarDatosDeFallecidos'
import CrearSolicitudesDeEmpadronamiento from 'services/solicitudesDeEmpadronamientoEnElExtranjero'
import EstadisticasSolicitudes from 'services/EstadisticasSolicitudes'
import ReportarCasosAInformatica from 'services/ReportarCasosAInformatica'
import ConsultaSolicitud from 'services/ConsultaSolicitud'
//fallecidos
import CaptacionFallecidos from 'services/CaptacionFallecidos'
import CaptacionHistorico from 'services/CaptacionHistorico'
import Padron from 'services/ModificarPadronPorFallecido'
import HabilitacionDeFallecidos from 'services/HabilitacionDeFallecidos'

import ActaVencimientoDePlazoParaDeclararCambioDeResidenciaDeUnMunicipioAOtro from 'services/ActaVencimientoDePlazoParaDeclararCambioDeResidenciaDeUnMunicipioAOtro'
import GenerarInformeCierre from 'services/InformeDeCierrePadron'
import CreacionDeUsuariosSSO from 'services/CreacionDeUsuariosSSO'
import ReportesEstadisticos from 'services/ReportesEstadisticos'
import TabalaUsuariosDS from 'services/CambiarPuestoULugarDeEmpadronamiento'
class ApiServices{
    constructor(){
        this.company = new Company();
        this.user = new User();
        this.userSecurity=new UserSecurity();
        this.solicitudesDeEmpadronamiento = new SolicitudesDeEmpadronamiento();
        this.registrosDeContactoParaValidarDatosDeSolicitudesConCiudadanos = new RegistrosDeContactoParaValidarDatosDeSolicitudesConCiudadanos();
        this.ConsultarDatosDeFallecidos = new ConsultarDatosDeFallecidos();
        this.verificarSolicitudDeEmpadronamiento = new VerificarSolicitudDeEmpadronamiento();
        this.constanciaEmpadronamiento = new ConstanciaEmpadronamiento();
        this.crearSolicitudesDeEmpadronamiento = new CrearSolicitudesDeEmpadronamiento();
        this.verificarHomonimos = new VerificarHomonimos();
        this.estadisticasSolicitudes = new EstadisticasSolicitudes();
        this.empadronamiento = new Empadronamiento();
        this.ocupaciones = new ApiGenericServicesData("ocupaciones");
        this.paises = new ApiGenericServicesData("paises");
        this.estadosDePaises = new ApiGenericServicesData("estadosDePaises");
        this.ciudades = new ApiGenericServicesData("ciudades");
        this.departamentos = new ApiGenericServicesData("departamentos");
        this.municipios = new ApiGenericServicesData("municipios");
        this.comunidades = new ApiGenericServicesData("comunidades");
        this.paises = new ApiGenericServicesData("paises");
        this.estadosDePaises = new ApiGenericServicesData("estadosDePaises");
        this.ciudades = new ApiGenericServicesData("ciudades");
        this.estadisticasSolicitudesGeneral = new ApiGenericServicesData("estadisticasSolicitudesGeneral");
        this.estadisticasSolicitudesCoordinadores = new ApiGenericServicesData("estadisticasSolicitudesCoordinadores");
        this.reportarCasosAInformatica = new ReportarCasosAInformatica();
        this.citasEmpadronamientoActualizacion = new ApiGenericServicesData("citasEmpadronamientoActualizacion");
        this.catalogoTimezone = new ApiGenericServicesData("catalogoTimezone");
        
        
        this.CatalogoDeRechazoEmpadronamientoCiudadano = new ApiGenericServicesData("CatalogoDeRechazoEmpadronamientoCiudadano");
        this.CatalogoDeRechazoEmpadronamientoInterno = new ApiGenericServicesData("CatalogoDeRechazoEmpadronamientoInterno");
        this.consultarRegistrosDeEmpadronamientoYRenap = new ApiGenericServicesData("consultarRegistrosDeEmpadronamientoYRenap");
        this.casosEspeciales = new ApiGenericServicesData("casosEspeciales");
        this.estadisticaDelegaciones = new ApiGenericServicesData("estadisticaDelegaciones");
        //discapacidades
        this.discapacidades = new ApiGenericServicesData("discapacidades");
        this.subdiscapacidades = new ApiGenericServicesData("subdiscapacidades");

        //ActaVencimientoDePlazoParaDeclararCambioDeResidenciaDeUnMunicipioAOtro
        this.actaVencimientoDePlazoParaDeclararCambioDeResidenciaDeUnMunicipioAOtro = new ActaVencimientoDePlazoParaDeclararCambioDeResidenciaDeUnMunicipioAOtro();
        //informe de cierre de padron
        this.generarInformeCierre = new GenerarInformeCierre();
        
        //consulta de datos a renap
        this.ConsultaSolicitud = new ConsultaSolicitud();
        
        // fallecidos
        this.captacionFallecidos = new CaptacionFallecidos;
        this.captacionHistorico = new CaptacionHistorico;
        this.habilitacion = new HabilitacionDeFallecidos;
        this.Padron = new Padron;
        this.captacionBitacora = new ApiGenericServicesData("captacionBitacora");
        // modulo de creacion de usuarios en el sso
        this.CreacionDeUsuariosSSO = new CreacionDeUsuariosSSO;
        // modulo para reportes
        this.reportesEstadisticos = new ReportesEstadisticos;
        // catalogos de departamento y municipios para el sistema de fallecidos
        this.catalogoDepartamentosDicep = new ApiGenericServicesData("catalogoDepartamentosDicep");
        this.catalogoMunicipiosDicep = new ApiGenericServicesData("catalogoMunicipiosDicep");
        this.auxiliaturas = new ApiGenericServicesData("auxiliaturas");

        //modulo para cambio de puesto u lugar de empadronamiento 
        this.puestoEmpadronamiento = new ApiGenericServicesData("puestoEmpadronamiento");
        this.tabalaUsuariosDS = new TabalaUsuariosDS();

        this.estadospadron = new ApiGenericServicesData("estadospadron");
        this.contadorSolicitudes = new ApiGenericServicesData("contadorSolicitudes");

    }
}

export default new ApiServices();

